__turbopack_context__.v({
  "show_row": "_7l6pHG_show_row",
  "show_row__show_poster": "_7l6pHG_show_row__show_poster",
  "splide__slide": "_7l6pHG_splide__slide",
  "top_ten_item": "_7l6pHG_top_ten_item",
  "top_ten_item__count": "_7l6pHG_top_ten_item__count",
  "top_ten_item__poster_container": "_7l6pHG_top_ten_item__poster_container",
  "top_ten_show_row": "_7l6pHG_top_ten_show_row",
});
